function ArrowInsideCircleIcon() {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="none"
                  viewBox="0 0 50 50"
            >
                  <rect
                        width="48.941"
                        height="48.941"
                        x="0.5"
                        y="0.5"
                        stroke="#005BB2"
                        rx="24.471"
                  ></rect>
                  <path
                        stroke="#005BB2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="1.5"
                        d="M22.396 18.96h8.585v8.584M18.96 30.981l11.9-11.9"
                  ></path>
            </svg>
      );
}

export default ArrowInsideCircleIcon;
